import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";

export default function StickyShop() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/product/") || pathname.startsWith("/admin")) return null;
  return (
    <div className="fixed inset-x-4 bottom-4 z-40 md:hidden">
      <Link
        to="/shop"
        data-testid="sticky-shop-button"
        className="btn-chunky w-full bg-blue px-6 py-4 text-base text-white shadow-hard-lg hover:bg-coral"
      >
        <ShoppingBag className="h-5 w-5" /> Shop the 90s
      </Link>
    </div>
  );
}
